import React, { useContext } from 'react';
import { IndexContext } from '../../context'

const AllInclude = ({ iconsSection, styles = {} }) => {
  const { baseUrl } = useContext(IndexContext);

  return (
    <section className="index-all-include container-block">
      <h2 className="index-all-include-h2">All Accounts Include:</h2>
      <div className="index-all-include-items js--index-all-include-items">
        {iconsSection.map((el, index) => (
            <figure className="index-all-include-figure" key={index}>
              <div className={`index-all-include-icon-wrap ${styles.allIncludeIcons}`}>
                <svg width={el.ico.width} height={el.ico.height} className="svg-sprite">
                  <use href={`${baseUrl}${el.ico.href}`}/>
                </svg>
              </div>
              <figcaption className="index-all-include-text">{el.title}</figcaption>
            </figure>
          ))}
      </div>
    </section>
  );
};

export default AllInclude;
